import { render } from "./StarFighterGame.vue?vue&type=template&id=2590a04e&scoped=true"
import script from "./StarFighterGame.vue?vue&type=script&lang=js"
export * from "./StarFighterGame.vue?vue&type=script&lang=js"

import "./StarFighterGame.vue?vue&type=style&index=0&id=2590a04e&scoped=true&lang=css"
import "./StarFighterGame.vue?vue&type=style&index=1&id=2590a04e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2590a04e"]])

export default __exports__